// @flow

import stores from 'stores';

export default (storeId: string, companyId: string) => {
  return stores.doddleStores.approveStore(storeId, companyId);
};
